document.addEventListener('DOMContentLoaded', function() {
    // Description tabs functionality
    const descriptionTabs = document.querySelectorAll('[data-description-tab]');
    const descriptionContents = document.querySelectorAll('#opis, #sklad, #pielegnacja');

    if (descriptionTabs.length > 0) {
        // Initialize: Set first tab as active and show first content
        function initializeTabs() {
            // Reset all tabs
            descriptionTabs.forEach(tab => {
                tab.classList.remove('border-black');
                tab.classList.add('border-[#F0F0F0]');
            });

            // Reset all content
            descriptionContents.forEach(content => {
                content.classList.add('hidden');
            });

            // Set first tab as active
            descriptionTabs[0].classList.remove('border-[#F0F0F0]');
            descriptionTabs[0].classList.add('border-black');

            // Show first content (opis)
            const firstContent = document.getElementById('opis');
            if (firstContent) {
                firstContent.classList.remove('hidden');
            }
        }

        // Initialize tabs on page load
        initializeTabs();

        // Tab click handlers
        descriptionTabs.forEach(tab => {
            tab.addEventListener('click', function() {
                const targetTab = this.getAttribute('data-description-tab');

                // Remove active state from all tabs
                descriptionTabs.forEach(t => {
                    t.classList.remove('border-black');
                    t.classList.add('border-[#F0F0F0]');
                });

                // Add active state to clicked tab
                this.classList.remove('border-[#F0F0F0]');
                this.classList.add('border-black');

                // Hide all content sections
                descriptionContents.forEach(content => {
                    content.classList.add('hidden');
                });

                // Show target content
                const targetContent = document.getElementById(targetTab);
                if (targetContent) {
                    targetContent.classList.remove('hidden');
                }
            });
        });
    }
});